import styled from 'styled-components';
import SecuritiesInputNumber from '../InputNumber';

export const Container = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  border-radius: 2px;
  border: 1px solid #dadada;
  padding: 4px 12px;
`;

export const InputNumber = styled(SecuritiesInputNumber)`
  & {
    border: 0;
    padding: 0;
    width: 100%;
    text-align: right;
    box-shadow: none !important;
  }
`;
